/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import axios from "axios";
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import useStyles from './style';
import StepIcon from 'components/StepIcon';
import Back from 'assets/svg/back';
import PaymentMethod from 'components/PaymentMethod';
import { Box, Button, Flex } from '@chakra-ui/react';
import { Divider } from '@mui/material';

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#8C9197',
    },
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#1A7431',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#1A7431',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const steps = ['Select Service', 'Confirm Order', 'Payment'];


const Matching = (props) => {
  const [activeStep, setActiveStep] = useState(0);
  const [service, setService] = useState([]);
  const [selectedService, setSelectedService] = useState();
  // const [selectedService, setSelectedService] = useState({});
  const [user, setUser] = useState({});
  const styles = useStyles();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (props?.match?.params?.id && props?.match?.params?.type) {
      axios.get(`https://api.personatalenta.id/user/${props?.match?.params?.type}/${props.match.params.id}`, {headers: {Authorization: `Bearer ${token ? token : ''}`, "Content-Type": "x-www-from-urlencode",  'Access-Control-Allow-Origin': 'http://localhost:3000', 'Access-Control-Allow-Credentials': 'true', 'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept' }})
      .then(res => {
        setUser(res.data.user ?? res.data.colleagues)
      }).catch(err => {
        if (err.response?.data?.message === "Unauthorized" || err.response?.data === "Unauthorized") {
          // navigate('/');
        }
      })
    } else {
      let localUser = localStorage.getItem('user');
      if(localUser) {
        setUser(JSON.parse(localUser))
      } else {
        window.location.assign('/home')
      }
    }
    if (token) {
      axios.get(`https://api.personatalenta.id/product/list`, {headers: {Authorization: `Bearer ${token ? token : ''}`, "Content-Type": "x-www-from-urlencode"}})
      .then(res => {
        const data = res.data.products.filter((product) => product.code === "persona_daily_vibe_1" || product.code === "persona_daily_vibe_10" || product.code === "persona_daily_vibe_20")
        setService(data)
      }).catch(err => {
        if (err.response.data.message === "Unauthorized" || err.response.data === "Unauthorized") {
          // navigate('/');
        }
      })  
    } else {
      // navigate('/')
    }
  }, []);

  const handleBuy = params => {
    setSelectedService(params);
    setActiveStep(activeStep+1)
  }

  return (
    <div className={styles.app}>
      <div className={styles.services}>
        <div className={styles.containerContent}>
          <div className={styles.stepperContainer}>
            <div onClick={activeStep === 0 ? () => window.history.go(-1) : () => setActiveStep(activeStep - 1)} className={styles.backButton}>
              <Back />
            </div>
            <div className="step">
              <Stepper activeStep={activeStep} alternativeLabel connector={<QontoConnector />}>
                {steps.map((label, index) => {
                  const stepProps = {};
                  
                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel StepIconComponent={StepIcon}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
            </div>
          </div>
          {activeStep === steps.length ? (
            <React.Fragment>
              <Typography sx={{ mt: 2, mb: 1 }}>
                All steps completed - you&apos;re finished
              </Typography>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {activeStep === 0 && (
                <div>
                  <div className={styles.descContainer}>
                    <div className="center">
                      <h6 className="title-type">MATCHING TYPE</h6>
                    </div>
                    <div className="row">
                      <div className="type-partnership">
                        <h6 className="feat-title">Partnership</h6>
                        <div className="row">
                          <div>
                            <h6 className="content">{service[0]?.duration} {service[0]?.duration_type}</h6>
                            <h6 className="content">Rp {new Intl.NumberFormat('id-ID').format(service[0]?.price)}</h6>
                            <div className={styles.btnBuy} onClick={() => handleBuy(service[0])}>
                              <span>Beli</span>
                            </div>
                          </div>
                          <div>
                            <h6 className="content">{service[1]?.duration} {service[1]?.duration_type}</h6>
                            <h6 className="content">Rp {new Intl.NumberFormat('id-ID').format(service[1]?.price)}</h6>
                            <div className={styles.btnBuy} onClick={() => handleBuy(service[0])}>
                              <span>Beli</span>
                            </div>
                          </div>
                          <div>
                            <h6 className="content">{service[2]?.duration} {service[2]?.duration_type}</h6>
                            <h6 className="content">Rp {new Intl.NumberFormat('id-ID').format(service[2]?.price)}</h6>
                            <div className={styles.btnBuy} onClick={() => handleBuy(service[0])}>
                              <span>Beli</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <Divider orientation="vertical" flexItem />
                      <div>
                        <h6 className="feat-title">Romance</h6>
                        <div className="row">
                          <div>
                            <h6 className="content">{service[0]?.duration} {service[0]?.duration_type}</h6>
                            <h6 className="content">Rp {new Intl.NumberFormat('id-ID').format(service[0]?.price)}</h6>
                            <div className={styles.btnBuy} onClick={() => handleBuy(service[0])}>
                              <span>Beli</span>
                            </div>
                          </div>
                          <div>
                            <h6 className="content">{service[1]?.duration} {service[1]?.duration_type}</h6>
                            <h6 className="content">Rp {new Intl.NumberFormat('id-ID').format(service[1]?.price)}</h6>
                            <div className={styles.btnBuy} onClick={() => handleBuy(service[0])}>
                              <span>Beli</span>
                            </div>
                          </div>
                          <div>
                            <h6 className="content">{service[2]?.duration} {service[2]?.duration_type}</h6>
                            <h6 className="content">Rp {new Intl.NumberFormat('id-ID').format(service[2]?.price)}</h6>
                            <div className={styles.btnBuy} onClick={() => handleBuy(service[0])}>
                              <span>Beli</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <Divider orientation="vertical" flexItem />
                      <div>
                        <h6 className="feat-title">Friendship</h6>
                        <div className="row">
                          <div>
                            <h6 className="content">{service[0]?.duration} {service[0]?.duration_type}</h6>
                            <h6 className="content">Rp {new Intl.NumberFormat('id-ID').format(service[0]?.price)}</h6>
                            <div className={styles.btnBuy} onClick={() => handleBuy(service[0])}>
                              <span>Beli</span>
                            </div>
                          </div>
                          <div>
                            <h6 className="content">{service[1]?.duration} {service[1]?.duration_type}</h6>
                            <h6 className="content">Rp {new Intl.NumberFormat('id-ID').format(service[1]?.price)}</h6>
                            <div className={styles.btnBuy} onClick={() => handleBuy(service[0])}>
                              <span>Beli</span>
                            </div>
                          </div>
                          <div>
                            <h6 className="content">{service[2]?.duration} {service[2]?.duration_type}</h6>
                            <h6 className="content">Rp {new Intl.NumberFormat('id-ID').format(service[2]?.price)}</h6>
                            <div className={styles.btnBuy} onClick={() => handleBuy(service[0])}>
                              <span>Beli</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.containerFeature}>
                    <div className="row">
                      <div className="feat">
                        <h5 className="feat-title">Partnership</h5>
                        <p className="feat"><span>•</span> Bar chart Result for General Matched (%)</p>
                        <p className="feat"><span>•</span> Partnership Matched</p>
                        <p className="feat"><span>•</span> Partnership Guidance</p>
                        <p className="feat"><span>•</span> Relation Style</p>
                        <p className="feat"><span>•</span> Interaction</p>
                        <p className="feat"><span>•</span> Deal With</p>
                        <p className="feat"><span>•</span> Bar chart Result for Today Matched (%)</p>
                        <p className="feat"><span>•</span> Daily Partnership</p>
                        <p className="feat"><span>•</span> Business Perspective</p>
                        <p className="feat"><span>•</span> Good Dealing</p>
                        <p className="feat"><span>•</span> Improving Performance</p>
                        <p className="feat"><span>•</span> Situation of The Day</p>
                      </div>
                      <Divider orientation="vertical" flexItem />
                      <div className="feat">
                        <h5 className="feat-title">Romance</h5>
                        <p className="feat"><span>•</span> Bar chart Result for General Matched (%)</p>
                        <p className="feat"><span>•</span> Romance Matched</p>
                        <p className="feat"><span>•</span> Romance Compatibility</p>
                        <p className="feat"><span>•</span> Guide Interaction</p>
                        <p className="feat"><span>•</span> Love Life</p>
                        <p className="feat"><span>•</span> Sex Life</p>
                        <p className="feat"><span>•</span> Bar chart Result for Today Matched (%)</p>
                        <p className="feat"><span>•</span> Daily Romance</p>
                        <p className="feat"><span>•</span> Romance Guidance</p>
                        <p className="feat"><span>•</span> Situation of The Day</p>
                      </div>
                      <Divider orientation="vertical" flexItem />
                      <div className="feat">
                        <h5 className="feat-title">Friendship</h5>
                        <p className="feat"><span>•</span> Bar chart Result for General Matched (%)</p>
                        <p className="feat"><span>•</span> Friendship Matched</p>
                        <p className="feat"><span>•</span> Relationship</p>
                        <p className="feat"><span>•</span> Guide on Friendship</p>
                        <p className="feat"><span>•</span> Tips and Ideas</p>
                        <p className="feat"><span>•</span> Interaction</p>
                        <p className="feat"><span>•</span> Bar chart Result for Today Matched (%)</p>
                        <p className="feat"><span>•</span> Daily Friendship</p>
                        <p className="feat"><span>•</span> Friends Activity and Traveling</p>
                        <p className="feat"><span>•</span> Situation of The Day</p>
                      </div>
                      {/* <p className="feat"><span>•</span> Daily Analytic</p>
                      <p className="feat"><span>•</span> Situation Of the Day</p>
                      <p className="feat"><span>•</span> Love and Relationship Character</p> */}
                    </div>
                    {/* <div className="row">
                      <p className="feat"><span>•</span> Health</p>
                      <p className="feat"><span>•</span> Travel and Recreation</p>
                      <p className="feat"><span>•</span> Business And Wealth</p>
                    </div> */}
                  </div>
                </div>
              )}
              {activeStep === 1 && (
                <div className={styles.containerStepTwo}>
                  <div className={styles.containerTopTwo}>
                    <h4 className="title">Service Checkout</h4>
                    <p className="content">Please check again the data you provided below and service you want to order. </p>
                  </div>
                  <div className={styles.containerCenter}>
                    <div className={styles.containerLeft}>
                      <div className={styles.containerOrder}>
                        <h6 className="title">Name</h6>
                        <p className="content">{user.name}</p>
                      </div>
                      <div className={styles.containerOrder}>
                        <h6 className="title">Birth Date</h6>
                        <p className="content">{user.birth_date}</p>
                      </div>
                      <div className={styles.containerOrder}>
                        <h6 className="title">Gender</h6>
                        <p className="content">{user.gender === 0 ? "Male" : "Female"}</p>
                      </div>
                    </div> 
                    <div className={styles.containerLeft}>
                      <div className={styles.containerOrder}>
                        <h6 className="title">Service Type</h6>
                        <p className="content">{selectedService.name}</p>
                      </div>
                      <div className={styles.containerOrder}>
                        <h6 className="title">Total Price</h6>
                        <div>
                          <p className="content">Rp {new Intl.NumberFormat('id-ID').format(selectedService.price)}</p>
                          <p className="note">Price exclude tax and fee</p>
                          <Button
                            borderWidth={1}
                            borderColor="#1A7431"
                            bgColor="#1A7431"
                            color='#fff'
                            fontSize='sm'
                            w="100%"
                            fontWeight='bold'
                            borderRadius='5px'
                            px='10px'
                            py='10px'
                            onClick={() => setActiveStep(activeStep + 1)}
                          >
                            {"Lanjutkan pembayaran"}
                          </Button>
                        </div>
                      </div>
                    </div> 
                  </div>
                </div>
              )}
              {activeStep === 2 && (
                <PaymentMethod productId={selectedService?.id} user={user} isUser={props?.match?.params?.type !== 'colleague'} />
              )}
            </React.Fragment>
          )}
        </div> 
      </div>
    </div>
  );
}

export default Matching;
